import * as React from "react";
import { Button, Drawer } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
const { useState, useEffect, forwardRef, useImperativeHandle } = React;
const LabelInformation = forwardRef((props, ref) => {
  const [open, setOpen] = useState(false);
  const [size, setSize] = useState('large');

  if (!props.attributes.information.length) {
    return;
  }
  useEffect(() => {
    // ComponentDidMount logic here
    return () => {
      // ComponentWillUnmount logic here
      setOpen(false);
    };
  }, []);

  useImperativeHandle(ref, () => ({
    updateState(newState) {
      setOpen(newState);
    }
  }));

  const onClose = () => {
    setOpen(false);
  };

  const showDrawer = () => {
    setOpen(true);
  };

  function createMarkup() {
    return {__html: props.attributes.information};
  }

  return (
    <>
      <InfoCircleOutlined onClick={showDrawer} />
      <Drawer
        title={props.attributes.label}
        placement="right"
        onClose={onClose}
        open={open}
      >
      <div dangerouslySetInnerHTML={createMarkup()}/>
      </Drawer>
    </>
  );
});
export default LabelInformation;